import React, { useState } from "react";
import logo from "../assets/logo.png";
import { useLanguage } from "../contexts/LanguageContext";

const navLinks = [
  { href: "/", en: "Home", pt: "Início" },
  { href: "/collections", en: "Collections", pt: "Coleções" },
  { href: "/gallery", en: "Gallery", pt: "Galeria" },
];

export const Header = () => {
  const { language, toggleLanguage } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-cream/95 backdrop-blur-sm border-b border-stone-200">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-28">
        {/* Hamburger (mobile) */}
        <button
          className="lg:hidden p-2 text-stone-600 hover:text-gold-dark transition-colors"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={language === "pt" ? "Abrir menu" : "Toggle menu"}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M4 6h16M4 12h8m-8 6h16"
            />
          </svg>
        </button>

        {/* Logo */}
        <a href="/" className="flex items-center">
          <img src={logo} alt="TamTam Jewelry" className="h-24 w-auto" />
        </a>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-10">
          {navLinks.map(({ href, en, pt }) => (
            <a
              key={href}
              href={href}
              className="text-xs tracking-widest uppercase text-stone-500 hover:text-gold-dark transition-colors duration-200"
            >
              {language === "pt" ? pt : en}
            </a>
          ))}
        </nav>

        {/* Language toggle */}
        <button
          onClick={toggleLanguage}
          className="text-xs tracking-widest font-medium text-stone-500 hover:text-gold-dark transition-colors duration-200"
        >
          <span
            className={language === "en" ? "text-stone-900 font-semibold" : ""}
          >
            ENG
          </span>
          <span className="mx-1.5 text-stone-300">/</span>
          <span
            className={language === "pt" ? "text-stone-900 font-semibold" : ""}
          >
            PT
          </span>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="lg:hidden bg-cream border-t border-stone-200 px-6 py-5 flex flex-col gap-5">
          {navLinks.map(({ href, en, pt }) => (
            <a
              key={href}
              href={href}
              className="text-xs tracking-widest uppercase text-stone-500 hover:text-gold-dark"
              onClick={() => setMenuOpen(false)}
            >
              {language === "pt" ? pt : en}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;
